import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GlobalComponent } from 'src/app/global/global.component';
import { GeneralService } from 'src/app/service/general.service';
import { EDI271BO } from '../../eligibility270/eligibility270.model';
import { GetEDI271ClientBO } from '../client-parent.model';
import { CommonApiService } from 'src/app/commonapiservice';

@Component({
  selector: 'app-eligibility-details',
  templateUrl: './eligibility-details.component.html',
  styleUrls: ['./eligibility-details.component.scss']
})
export class EligibilityDetailsComponent implements OnInit {
  private onDestroy$: Subject<void> = new Subject<void>();
  @Input() Id;
  viewFiles271: boolean = false;
  edi271list: EDI271BO[] = [];;
  @Output() Event = new EventEmitter<GetEDI271ClientBO>();
  constructor(public datepipe: DatePipe, public global: GlobalComponent,
    public CommonAPI: CommonApiService, public general: GeneralService,  public router: Router, public toastrService: ToastrService, private ref: ChangeDetectorRef) { }
  ngOnInit(): void {
    this.viewlasteb(this.Id);
  }
  viewlasteb(id) {
    let myparams = new URLSearchParams();
    myparams.append("id", id);
    let url = "api/ClaimProcess/GetClients271Detail?";
    this.CommonAPI.GetFunctionwithResponseTypeJson(myparams, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.edi271list = data;
      this.viewFiles271 = true;
    },
      (err: any) => {
        this.toastrService.error(err, 'error')
      }
    );
  }
  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }
}
